/** Tones for StatusPill and the order, fulfillment, and shipment states that map to them. */
export type StatusTone = 'success' | 'progress' | 'warning' | 'danger' | 'neutral'

/** "PARTIALLY_FULFILLED" or "partially_fulfilled" → "Partially fulfilled". */
export function sentenceCase(value: string) {
  const words = value.replace(/[_-]+/g, ' ').trim().toLowerCase()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

export function paymentTone(status: string | null | undefined): StatusTone {
  switch ((status ?? '').toLowerCase()) {
    case 'paid':
      return 'success'
    case 'partially_paid':
    case 'pending':
    case 'authorized':
      return 'warning'
    case 'refunded':
    case 'partially_refunded':
    case 'voided':
      return 'danger'
    default:
      return 'neutral'
  }
}

export function fulfillmentTone(status: string | null | undefined): StatusTone {
  switch ((status ?? '').toLowerCase()) {
    case 'fulfilled':
      return 'success'
    case 'partially_fulfilled':
    case 'partial':
    case 'in_progress':
      return 'warning'
    case 'restocked':
      return 'danger'
    default:
      return 'neutral'
  }
}

export function shipmentTone(status: string | null | undefined): StatusTone {
  switch (status ?? '') {
    case 'delivered':
      return 'success'
    case 'shipped':
    case 'in_transit':
    case 'booked':
      return 'progress'
    case 'ready_to_book':
    case 'pending':
      return 'warning'
    case 'exception':
    case 'delivery_exception':
    case 'delayed':
    case 'failed':
    case 'delivery_failed':
    case 'returned':
      return 'danger'
    default:
      return 'neutral'
  }
}
